import 'styles/tailwindcss.scss';
import React from 'react';
import toast from 'react-hot-toast';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TextIconInput from 'components/input/TextIconInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { USER_ROLE } from 'constants/common';
import { useHistory } from 'react-router';
import { routers } from 'router/router';
import { useAppDispatch } from 'app/hooks';
import partnerServices from 'services/partnerServices';
import collegeServices from 'services/collegeServices';
import basicInformationServices from 'services/basicInformationApi';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
interface Props {
  onNextStep: (step: string) => void;
  formik: any;
}
  
const FormInviteStudent = ({ formik, onNextStep }: Props) => {
    const SEND_MAIL = true;
    const [loading, setLoading] = React.useState(false);
    let history = useHistory();
    const dispatch:any = useAppDispatch();
    const studentId = getUserId();
    //const graduationYearOptions = [0, 1, 2, 3, 4, 5, 6, 7].map((i) => i + new Date().getFullYear()-1);

    const inviteformik = useFormik({
        initialValues: {
          student_email: '',
          //graduate_year: new Date().getFullYear() + 1,
        },
        validationSchema: Yup.object().shape({
          student_email: Yup.string().email('Invalid email').required('This field is required'),
          ///graduate_year: Yup.string().required('This field is required'),
        }),
        onSubmit: async (values) => {
          console.log('inviteformik: run submit ~ values:', values);
          let token = getAccessToken();
          if (token && studentId) {
            setLoading(true);
            try {
              let parentObj:any = await basicInformationServices.getBasicDetail(studentId);
              let studentObj:any = await partnerServices.getStudentByEmail(values.student_email);
              if (parentObj==null) {
                toast.error('Server Error: Parent record not found.');
                return;
              }
              if (studentObj==null) {            
                inviteformik.setErrors({ 'student_email':  `Student not found. Please try another email.` }); 
                inviteformik.setFieldTouched('student_email', true, false); 
                return;
              }
    
              let approveUrl = `${process.env.REACT_APP_API_URL}/#/settings?active-tab=6`;
              if (studentObj && studentObj.user_role === USER_ROLE.student) {      
                console.log('studentObj:', studentObj);
                let res=  await partnerServices.parent_InviteStudent(studentId, values.student_email);
                console.log('parent_InviteStudent() ~ res:', res);  
                if (res && res.statusCode === 200) {
                  inviteformik.setErrors({ 'student_email':  res?.message ?? '' }); 
                  inviteformik.setFieldTouched('student_email', true, false); 

                  if (SEND_MAIL) {
                    try {
                      let sender = parentObj?.email ?? formik.values.email;
                      // send Invite Email to student
                      await collegeServices.sendParentInvitationStudentEmail({
                        studentEmail: values.student_email ?? studentObj.email,
                        sender: sender,
                        username: studentObj.first_name,
                        parentFirstname: parentObj.first_name, 
                        parentLastname: parentObj.last_name,
                        parentEmail: parentObj.email,
                        approveUrl: approveUrl
                      });
                    }
                    catch(ex2) {
                      console.log('Error: ', ex2);
                    }
                  }
                  onNextStep('phone');
                }
              }
              else {
                inviteformik.setErrors({ 'student_email':  `Student not found. Please try another email.`}); 
                inviteformik.setFieldTouched('student_email', true, false);    
              }
            } 
            catch (error:any) {
              console.log('invite error: ', error);
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx.
                console.log(error.response.data); // Specific error details from the server
                console.log(error.response.status); // e.g., 400, 401, 404, 500
                console.log(error.response.headers);

                const message:string = error.response.data.message ??'';               
                if (message) {
                  inviteformik.setErrors({ 'student_email': `${message}` }); 
                  inviteformik.setFieldTouched('student_email', true, false); 
                }
              } else if (error.request) {
                // The request was made but no response was received (e.g., network error, server down).
                console.log(error.request);
                inviteformik.setErrors({ 'student_email': "Network Error: No response received."}); 
                inviteformik.setFieldTouched('student_email', true, false); 
              } else {
                // Something else happened while setting up the request that triggered an Error.
                inviteformik.setErrors({ 'student_email': `Error: ${error.message}`}); 
                inviteformik.setFieldTouched('student_email', true, false);
              }        
            }
            setLoading(false);
          }
          else {
            handleLogout();
          }
        },
    });
  
    const handleLogout = () => {
      dispatch(logout());
      removeAccessToken();
      removeUserId();
      history.push(routers.login.path);
    };

    return (
    <div className="min-h-screen flex items-center justify-center p-0 mb-5 px-md-5 container">
      <div className="w-full max-w-lg mx-auto"> 
        <div id="title-section" className="d-block text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-gradmap-blue rounded-xl mb-4">
              <i className="text-white text-2xl" data-fa-i2svg=""><svg className="svg-inline--fa-24px fa-graduation-cap" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="graduation-cap" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"></path></svg></i>
          </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Let's set up your child's GradMap</h1>
            <p className="text-gray-600">You can invite your child to join later.</p>
        </div>

        <div id="setup-form-container" className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <div className="row">
              <div className="col-md-12">
                <TextIconInput
                  placeholder="Enter child's email"
                  className="signup-form"
                  labelCustom={(<span className="ml-1 text-gray-400 font-normal">(optional)</span>)}
                  icon={<MailOutlineIcon />}
                  mdCol={'6'}
                  label={`Child's Email`}
                  name="student_email"
                  values={inviteformik.values.student_email}
                  onChange={inviteformik.handleChange}
                  onBlur={inviteformik.handleBlur}
                  feedback={
                    (inviteformik.touched.student_email && inviteformik.errors.student_email && (
                        <span id="error_email" className="text-danger">
                            {inviteformik.errors.student_email}
                        </span>
                    ))
                  }
                  />
              </div>
          </div>

          {/* <div className="row">
          <div className="col-md-12 mt-6">
              <DropDownInput                       
              form={inviteformik}
              values={inviteformik.values.graduate_year}
              onChange={inviteformik.handleChange}
              name={'graduate_year'}
              label={'Graduation year'}
              labelClass="block text-sm font-semibold text-gray-900 mb-2"
              labelCustom={(<></>)}
              option={graduationYearOptions}
              feedback={
                  inviteformik.errors.graduate_year && (
                  <span className="text-danger">{inviteformik.errors.graduate_year}</span>
                  )
              }
              />
          </div>
          </div> */}

          <div className="pt-6">
          <button 
            type="button" 
            className="w-full bg-gradmap-blue hover:bg-gradmap-navy text-white font-semibold py-4 rounded-lg transition-all duration-200 shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 flex items-center justify-center space-x-2"
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              inviteformik.handleSubmit();
            }}
          >
              { loading ? 'Sending...' : 'Invite Student'}
          </button>
          </div>
          <div className="text-center mt-6">
          <button type="button" 
              className="text-gray-600 hover:text-gray-900 font-medium text-sm transition-colors"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onNextStep('phone');
              }}
            >
              Skip for now
          </button>
          </div>
          <div className="mt-6 border-t border-gray-200" style={{ borderTop: '1px solid rgb(229, 231, 235)' }}></div>
          <div className="mt-6">
            <div className="bg-blue-50 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <i className="text-gradmap-blue text-lg mt-0.5" data-fa-i2svg=""><svg className="svg-inline--fa fa-circle-info" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-info" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg></i>
                </div>
                <div className="text-sm text-gray-700">
                  <p>This creates a placeholder profile for your child. You'll be able to invite them to access their own GradMap account at any time.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
};


export default FormInviteStudent;